export default "__VITE_ASSET__aFH_qSrl__"